import { Document } from 'lib/documents/document';
import { httpsCallableWrapper } from '../api-_utils';
import { z } from 'zod';
import { API_ROUTE_CONFIG } from './api-config/config';

export interface ClinicianQueryArgs {
  question: string;
}

export const clinicianQueryResponseReferenceSchema = z.object({
  id: z.string(),
  title: z.string(),
  abstract: z.string(),
  publicationTypes: z.array(z.string())
});

export interface ClinicianQueryResponseReference extends Document {
  id: string;
  title: string;
  abstract: string;
  publicationTypes: string[];
}

export interface ClinicianQueryResponse {
  role: string;
  chatMessage: { role: 'assistant'; content: string };
  references: ClinicianQueryResponseReference[];
}

export const clinicianQuery = (args: ClinicianQueryArgs) =>
  httpsCallableWrapper<any, ClinicianQueryResponse>(
    API_ROUTE_CONFIG.clinic.query
  )(args);
